import React, { useState } from 'react';

import { type ModalProps } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';

import style from './style.module.less';

export interface IPohModalProps extends ModalProps {
  children?: React.ReactNode | ((closeHandler: () => void) => React.ReactNode);
}

const PohModal: React.FC<IPohModalProps> = ({
  title,
  footer,
  children,
  show: defaultShow = true,
  canClose,
  onClose = true,
  backdrop = true,
  closeOnBackdrop = true,
  size,
  keyboard = true,
  ...rest
}) => {
  const [show, setShow] = useState(defaultShow);
  const handleClose = () => {
    setShow(false);
    onClose();
  };

  const backdropVar = closeOnBackdrop ? true : 'static';

  return (
    <Modal
      {...rest}
      show={show}
      onHide={handleClose}
      backdrop={backdrop ? backdropVar : false}
      size={size}
      keyboard={keyboard}
      scrollable
      dialogClassName={style.dialog}
      backdropClassName={style.backdropClassName}
      dialogAs="dialog"
      open={show}
      role="dialog"
    >
      {title && (
        <Modal.Header closeButton={canClose} className="mb-0 pb-0">
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
      )}
      <Modal.Body style={{ overflowY: 'auto', maxHeight: '80vh' }}>
        {typeof children === 'function' ? children(handleClose) : children}
      </Modal.Body>
      {footer && (
        <Modal.Footer>{typeof footer === 'function' ? footer(handleClose) : footer}</Modal.Footer>
      )}
    </Modal>
  );
};

export default PohModal;
